import { TranslationKeys } from '../index';

export const de: TranslationKeys = {
  betBuilder: {
    title: 'Wett-Builder',
    noBetsSelected: 'Der Wett-Builder ist leer',
    addSelections: 'Auswahlen hinzufügen',
    totalOdds: 'Gesamtquoten',
    totalSelections: 'Gesamtauswahl',
    clearAll: 'Alle Löschen',
    removeBet: 'Wette entfernen',
    addBet: 'Wette hinzufügen',
    event: 'Ereignis',
    market: 'Markt',
    selection: 'Auswahl',
    odds: 'Quoten',
    confirmClear: 'Alle Wetten Löschen',
    confirmClearMessage: 'Sind Sie sicher, dass Sie alle Wetten entfernen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
    cancel: 'Abbrechen',
    confirm: 'Alle Löschen',
    closed: 'Geschlossen',
    suspend: 'Aussetzen',
    eventClosed: 'Ereignis Geschlossen',
    eventSuspended: 'Ereignis Ausgesetzt',
    buildABet: ''
  },
  betStatus: {
    won: 'Gewonnen',
    pending: 'Ausstehend',
    refund: 'Rückerstattung',
    lost: 'Verloren',
    halfwon: 'Halb Gewonnen',
    halflost: 'Halb Verloren',
    cashout: 'Auszahlung',
    unknown: 'Unbekannt'
  },
  common: {
    loading: 'Laden...',
    error: 'Fehler',
    retry: 'Wiederholen',
    close: 'Schließen',
    save: 'Speichern',
    edit: 'Bearbeiten',
    delete: 'Löschen',
    back: 'Zurück',
    next: 'Weiter',
    previous: 'Vorherige',
    search: 'Suchen',
    filter: 'Filtern',
    sort: 'Sortieren',
    settings: 'Einstellungen'
  },
  errors: {
    generic: 'Etwas ist schief gelaufen. Bitte versuchen Sie es erneut.',
    network: 'Netzwerkfehler. Bitte überprüfen Sie Ihre Verbindung.',
    notFound: 'Die angeforderte Ressource wurde nicht gefunden.',
    unauthorized: 'Sie sind nicht berechtigt, diese Aktion auszuführen.',
    validation: 'Bitte überprüfen Sie Ihre Eingabe und versuchen Sie es erneut.'
  }
};